import React from 'react'
import CardBillingTransactionReport from './CardBillingTransactionReport/CardBillingTransactionReport'
import CardTransactionDocumentsData from './CardTransactionDocumentsData/CardTransactionDocumentsData'
import MessagesListTransactionReport from './MessagesListTransactionReport/MessagesListTransactionReport'

const RightSideTransactionReport = () => {
    return (
        <div className="pl-20 pb-10 mb-10 mt-80 con-user-cards-bugs" style={{ width: "47%", paddingLeft: "5.7%" }}>
            <CardTransactionDocumentsData />
            <CardBillingTransactionReport />
            <MessagesListTransactionReport />
        </div>
    )
}

export default React.memo( RightSideTransactionReport )